import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { getUser } from '../redux/userActions'
import { getNotes} from '../redux/actions'
import { Loader } from 'semantic-ui-react'


class LoadingComponent extends Component {
  componentWillMount() {
    const { userLoading, notesLoading } = this.props
    if(userLoading == null){
      this.props.getUser()
    }
    if(notesLoading == null){
      this.props.getNotes()
    }

  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.notesLoading === -1 && nextProps.user != null) {
      this.props.getNotes()

    }

  }
  render() {
    const { userLoading, notesLoading, children} = this.props
    if ((!userLoading && !notesLoading) || this.props.user == null) {
      return <div>{children}</div>
    } else {
      return (
        <div style={{ marginTop: '6rem' }}>
         <Loader active inline='centered' />
        </div>
      )
    }
  }
}

function mapState(state) {
  return {
    user: state.user,
    userLoading: state.loading.user,
    notesLoading: state.loading.notes
  }
}

export default withRouter(connect(mapState, { getUser, getNotes })(LoadingComponent))




// WEBPACK FOOTER //
// ./src/components/LoadingComponent.js